import React, { FC, useCallback, useEffect } from 'react';
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import { Box } from '@material-ui/core';
import { ITreeViewSingle } from 'components/TreeViewSingle/types';
import TreeViewItem from './TreeViewItem';

const TreeViewSingle: FC<ITreeViewSingle> = ({
  nodes,
  value = '',
  onChange = () => {},
  defaultExpanded,
  expandedNodes,
  defaultCollapseIcon = <ExpandMoreIcon />,
  defaultExpandIcon = <ChevronRightIcon />,
  renderLabel,
  loadChildren,
  dynamicChildren,
}) => {
  const [selected, setSelected] = React.useState<string | undefined>(value);
  const [expanded, setExpanded] = React.useState<string[]>(expandedNodes || []);

  useEffect(() => {
    if (expandedNodes && !expandedNodes.some((node) => expanded.indexOf(node) >= 0)) {
      setExpanded([...expanded, ...expandedNodes]);
    }
  }, [expanded, expandedNodes]);

  const scrollToSelected = useCallback(() => {
    const [selectedNode] = document.getElementsByClassName('MuiTreeItem-root Mui-selected');

    if (selectedNode) {
      selectedNode.scrollIntoView();
    }
  }, []);

  useEffect(() => {
    if (value) scrollToSelected();
  }, [scrollToSelected, value]);

  const onLabelClick = (value: string) => {
    setSelected(value);
    onChange(value);
  };

  const handleToggle = (event: React.ChangeEvent<{}>, nodeIds: string[]) => {
    setExpanded(nodeIds);
  };

  return (
    <Box borderRadius={4} border={1} borderColor="#E5E5E5" borderBottom="none">
      <TreeView
        defaultCollapseIcon={defaultCollapseIcon}
        defaultExpanded={defaultExpanded}
        defaultExpandIcon={defaultExpandIcon}
        expanded={expanded}
        selected={selected}
        multiSelect={false}
        disableSelection
        onNodeToggle={handleToggle}
      >
        {nodes.map((node) => (
          <TreeViewItem
            key={`tree-item-${node.value}`}
            node={node}
            onLabelClick={onLabelClick}
            selected={selected}
            renderLabel={renderLabel}
            loadChildren={loadChildren}
            dynamicChildren={dynamicChildren}
          />
        ))}
      </TreeView>
    </Box>
  );
};

export default TreeViewSingle;
